const ssoLogin = {
  name: 'ssoLogin',
  path: 'sso',
  component: resolve => require(['../../../pages/custom/login/sso'], resolve)
}

export default ssoLogin
